// services
import useArtifactService from '../../../artifactService';
import useDocumentStorageService from '../../../../documentStorage/documentStorageService';
import BaseFileUploader, { UploadFileParams, UploadFileResponse } from './BaseFileUploader';

type FileUploaderProps = {
  validationCallback: (error: any) => void;
  validateFunc: (file: File[]) => any;
  uploadCallback: (id: string, file: File) => void;
  acceptExtensions: Nullable<string>;
  artifactTypeId: string;
  source: string;
  canAddFromClipboard?: boolean;
  showBtnImage?: boolean;
  uploadBtnText?: string;
  disabled?: boolean;
  uploadFile?: (params: UploadFileParams) => Promise<UploadFileResponse>;
  isNewDocumentStorage?: boolean;
  maxElements?: number;
  isRiskService?: boolean;
};

const FileUploader = ({ uploadFile, isNewDocumentStorage, isRiskService, ...props }: FileUploaderProps) => {
  const documentStorageService = useDocumentStorageService();
  const artifactService = useArtifactService({ uploadFile, isRiskService });
  const { uploadArtifact } = isNewDocumentStorage && !uploadFile ? documentStorageService : artifactService;

  return <BaseFileUploader {...props} uploadFile={uploadArtifact} />;
};

export default FileUploader;
